import styled from '@emotion/styled';
import { useDetermineMobile } from '@myrealtrip/device-detect';

import { getTravelerLink } from '../../utils/getTravelerLink';
import { getPartnerLink } from '../../utils/getPartnerLink';
import { globalVariables } from '../../../shared/designSystem/constants';
import { useEnvContext } from '../../../modules/EnvProvider';
import SiteMapItems from './SiteMapItems';
import { getSupportLink } from '../../utils/getSupportLink';

export default function SiteMap() {
  const { targetEnv } = useEnvContext();
  const isMobile = useDetermineMobile();

  const siteMapItems = [
    {
      title: '소개',
      items: [
        {
          label: '회사소개',
          link: 'https://about.myrealtrip.com',
        },
        {
          label: '채용',
          link: 'https://career.myrealtrip.com',
        },
        {
          label: '공고',
          link: getTravelerLink('/main/announcement', targetEnv),
        },
      ],
    },
    {
      title: '파트너',
      items: [
        {
          label: '파트너 홈',
          link: getPartnerLink('/welcome', targetEnv),
        },
        {
          label: '제휴 문의',
          link: 'mailto:marketing@myrealtrip.com',
        },
        {
          label: '광고 문의',
          link: 'mailto:ad@myrealtrip.com',
        },
      ],
    },
    {
      title: '지원',
      items: [
        {
          label: '공지사항',
          link: 'https://support.myrealtrip.com/notice',
        },
        {
          label: '문의내역',
          link: getSupportLink('/inquiry', targetEnv),
        },
        {
          label: '최저가 보장제',
          link: getTravelerLink('/main/best-price', targetEnv),
        },
      ],
    },
  ];

  const Container = isMobile ? MobileContainer : DesktopContainer;

  return (
    <Container>
      {siteMapItems.map(({ title, items }) => (
        <SiteMapItems key={title} title={title} menuItems={items} />
      ))}
    </Container>
  );
}

const CommonContainer = styled.div`
  display: flex;
`;

const MobileContainer = styled(CommonContainer)`
  width: 100%;
  margin-top: 32px;
  flex-direction: column;
  border-top: 1px solid ${globalVariables.gray_100};
`;

const DesktopContainer = styled(CommonContainer)`
  width: 50%;
`;
